import { render, staticRenderFns } from "./CockpitMatryoshkaInheritanceTreeSection.vue?vue&type=template&id=7c214050&scoped=true"
import script from "./CockpitMatryoshkaInheritanceTreeSection.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaInheritanceTreeSection.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaInheritanceTreeSection.vue?vue&type=style&index=0&id=7c214050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c214050",
  null
  
)

export default component.exports